import axios from 'axios';
import './axiosInterceptor';
export const PASARELA = process.env.VUE_APP_URLPASARELA;
export const Refunds = {
  // Datos de contracargos
  getContracargos(params) {
    return axios.get(PASARELA + "/administracion/contracargos", { params })
  },
}